(function () {
  document.querySelectorAll('[data-amati-slider]').forEach(function (wrapper) {
    var track   = wrapper.querySelector('.bdr-amati__track');
    var items   = Array.from(wrapper.querySelectorAll('.bdr-amati__item'));
    var dots    = Array.from(wrapper.querySelectorAll('.bdr-amati__dot'));
    var prevBtn = wrapper.querySelector('.bdr-amati__prev');
    var nextBtn = wrapper.querySelector('.bdr-amati__next');

    if (!track || items.length < 2) return;

    var current = 0;

    function getVisible() {
      if (window.innerWidth >= 990) return 4;
      if (window.innerWidth >= 750) return 3;
      return 1;
    }

    function getMax() {
      return Math.max(0, items.length - getVisible());
    }

    /* Calcola lo shift in pixel per la posizione n.
       All'ultima posizione usa lo shift esatto che porta il bordo destro
       dell'ultima card a toccare il bordo destro del viewport, evitando
       che l'ultima slide rimanga parzialmente fuori schermo. */
    function computeShift(n) {
      var max = getMax();
      if (n < max) {
        return n * items[0].offsetWidth;
      }
      /* Ultimo scatto: il bordo destro dell'ultima card va a filo di ciò che
         ritaglia. Da tablet in su è la finestra, larga quanto la gabbia di
         pagina; sul telefono le card corrono fino al bordo dello schermo e il
         riferimento resta l'intera fascia. */
      var viewportEl = track.parentElement;
      var stile = getComputedStyle(viewportEl);
      var totalTrack = items.reduce(function (s, item) { return s + item.offsetWidth; }, 0);
      if (stile.overflow === 'hidden') {
        return Math.max(0, totalTrack - viewportEl.clientWidth);
      }
      var paddingLeft = parseFloat(stile.paddingLeft) || 0;
      return Math.max(0, totalTrack + paddingLeft - wrapper.offsetWidth);
    }

    function goTo(n) {
      var max = getMax();
      if (max === 0) return;
      if (n < 0) n = max;
      if (n > max) n = 0;
      current = n;

      track.style.transform = 'translateX(-' + computeShift(current) + 'px)';

      dots.forEach(function (dot, i) {
        var visible = i <= max;
        dot.style.display = visible ? '' : 'none';
        dot.classList.toggle('is-active', i === current);
      });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.dataset.index, 10));
      });
    });

    var touchStartX = 0;
    wrapper.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].clientX;
    }, { passive: true });
    wrapper.addEventListener('touchend', function (e) {
      var delta = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(delta) < 50) return;
      goTo(delta < 0 ? current + 1 : current - 1);
    }, { passive: true });

    window.addEventListener('resize', function () {
      goTo(Math.min(current, getMax()));
    });

    goTo(0);
  });
})();
